import React from 'react';
import WaitingRoomPlayer from './WaitingRoomPlayer';
import { WaitingRoomPlayersInterface } from './WaitingRoomPlayersInterface';

function WaitingRoomThreePlayers({players, isHost}: WaitingRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="threePlayersWrapper1">
                <WaitingRoomPlayer name={players[1].name} image={players[1].image}/>
                <WaitingRoomPlayer name={players[2].name} image={players[2].image}/>
            </div>
            <div className="threePlayersWrapper2">
                <WaitingRoomPlayer name={players[0].name} image={players[0].image}/>
            </div>
        </div>
    );
};

export default WaitingRoomThreePlayers;